import Grid from '@mui/material/Grid';
import "./style.css";
import React from 'react';
import {useState, useEffect} from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import { purple } from '@mui/material/colors';
import Divider from '@mui/material/Divider';
import axios from 'axios';
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableBody from '@mui/material/TableBody';
import {read} from "./api.js";
import {readEmpty} from "./apiEmpty.js";
import NewCompanyPopUp from '../NewCompanyPopUp';
import NoTelpSearchPopUp from '../changeCompany'
import Dialog from '@mui/material/Dialog';
import {Typography} from '@mui/material/'
  const RedButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(purple[500]),
    backgroundColor: "#ff0000",
    '&:hover': {
      backgroundColor: "#8b0000",
    },
  }));

  export default function ConfirmCompany({closechangePerusahaanPopUPOpen,setContractData,contractData, handleCompany,handleCloseConfirm,nextButton, setCompanies, companies, handleCloseNoTelp, setcompanyID, setcompanyIDtoSave}){

    const [batas,setBatas] = useState("Yes");
    const [skip, setSkip] = useState(0)
    const [isEnd,setIsEnd] = useState("loading..")
    const [posts, setPosts] = useState([])
    const [query, setQuery] = useState('');

   
    
    useEffect(() => {
        fetchPosts();
    }, [skip,query]);
  

    const handleSearch = (event) =>{
        setQuery(event.target.value)
        setSkip(0)
        newFetchPosts(event)
    }
     

    const fetchPosts = async () => {
      if(query.trim()){
              try{
                  const { data, error } = await read(skip,query,batas, contractData.KlienID);
                  if(error){
                      console.log(error.message);
                      return;
                  }
      
                  if(data?.length === 0){
                      setIsEnd("Selesai...");
                      return;
                  }
                  
                  //success
                  setPosts([...posts, ...data[0].Companies])
              }catch(error){
                  console.log(error.message);
              }
          
      }else{
  
      try{
          const { data, error } = await readEmpty(skip,query,batas,contractData.KlienID);
          if(error){
              console.log(error.message);
              return;
          }
  
          if(data?.length === 0){
              setIsEnd("Selesai...");
              return;
          }
          console.log(data[0].Companies)
          //success
          setPosts([...posts, ...data[0].Companies])
          console.log(posts)
      }catch(error){
          console.log(error.message);
      } 
      }
  }  

  const newFetchPosts = async (event) => {
    setPosts([])
    setIsEnd("Loading...");
    if(event.target.value.trim()){
    try{
        const { data, error } = await read(skip,event.target.value,batas,contractData.KlienID);
        console.log("read(skip,event.target.value,batas,thisCompany)")

        console.log(read(skip,event.target.value,batas,contractData.KlienID))
        if(error){
            console.log(error.message);
            return;
        }
  
        if(data?.length === 0){
            setIsEnd("Selesai...");
            return;
        }
        //success
        setPosts([...data[0].Companies])
    }catch(error){
        console.log(error.message);
    }
    }else{
        console.log("empty")
        try{
            const { data, error } = await readEmpty(skip,event.target.value,batas,contractData.KlienID);
            if(error){
                console.log(error.message);
                return;
            }
  
            if(data?.length === 0){
                setIsEnd("Selesai...");
                return;
            }
            
            //success
            setPosts([...posts, ...data[0].Companies])
        }catch(error){
            console.log(error.message);
        } 
    }
  }

    const selectedCompany = (event) => {
        console.log(event.target.value)
    }
    const handleScroll = (e) => {
        const { offsetHeight, scrollTop, scrollHeight } = e.target;
    
        if(offsetHeight + scrollTop >= scrollHeight){
            setSkip(posts?.length);
        }
      }
      const [openNewCompany, setOpenNewCompany] = useState(false);

      const newCompany = () => {
        console.log("here")
        setOpenNewCompany(true);
    };
  
    const handleCloseNewCompany = () =>{
        setOpenNewCompany(false);
    }
    const BelumAda = () => {
        console.log(contractData);
        setContractData({...contractData, CompanyName: "", CompanyID: ""});  // Changed this line  
        closechangePerusahaanPopUPOpen();

    }
    const selectNamaPerusahaan = (post) => {
        console.log(post)
        closechangePerusahaanPopUPOpen()
        setContractData({...contractData, CompanyName: post.NamaPT, CompanyID: post.CompanyID});
    }
    return <Grid container>
    <Dialog open={openNewCompany} onClose={handleCloseNewCompany}>
                <NoTelpSearchPopUp setcompanyIDtoSave={setcompanyIDtoSave} closechangePerusahaanPopUPOpen={closechangePerusahaanPopUPOpen} setContractData={setContractData} contractData={contractData} companies={companies} setCompanies={setCompanies} selectNamaPerusahaan={selectNamaPerusahaan} handleCompany2={handleCompany} setcompanyID={setcompanyID} handleCloseNoTelp={handleCloseNoTelp}></NoTelpSearchPopUp>
    </Dialog>
    <Grid container align = "center" justify = "center" alignItems = "center" sx={{pt:5, px:2, pb:2}}>
                        <Grid sx={{mb:2}} sm={12}>
                                <Typography variant="h5"><b>Pilih Company/Perusahaan dibawah yang sesuai</b></Typography>
                                <Typography sx={{mt:1}}>Dibawah adalah daftar dari semua perusahaan yang terhubung dengan PIC/Direktur yang dipilih</Typography>

                        </Grid>
                        <Grid sx={{mb:2}} sm={12}>
                                <RedButton onClick={BelumAda}>Belum Ada/Masih dalam Proses</RedButton>
                                <Typography sx={{mt:2}}>Klik tombol diatas jika masih dalam proses Pendirian Legalitas, atau klik Others jika menggunakkan PIC/Direktur yang sama namun perusahaan belum pernah terhubung sebelumnya.</Typography>

                        </Grid>
                        <Grid container alignItems="center" sx={{mt:5, mb:2}}>
    <Grid item xs={9}>
        <TextField
            fullWidth
            value={query}
            onChange={handleSearch}
            placeholder="Search..."
        />
    </Grid>
    <Grid item xs={3}>
        <Button fullWidth onClick={newCompany}>
            Others
        </Button>
    </Grid>
</Grid>


                          <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                              <TableContainer sx={{ maxHeight: 400, minHeight: 350 }} className="min-h-screen h-screen overflow-scroll" onScroll={handleScroll}>
                                  <Table stickyHeader aria-label="sticky table">
                                      <TableHead>
                                          <TableRow>
                                              <TableCell>
                                                  Nama Company
                                              </TableCell>
                                              
                                          </TableRow>
                                      </TableHead>
                                      {posts?.map((companies) => (
                                          <TableBody>
                                              <TableRow key={`${companies.NamaPT}`}
                                                    hover
                                                    onClick={() => selectNamaPerusahaan(companies)}>
                                                  <TableCell style={{cursor:'pointer'}}>
                                                      <p>{companies.NamaPT}</p>
                                                  </TableCell>
                                              </TableRow>
                                          </TableBody>
                                      
                                      ))}
                                      {isEnd}
                                  </Table>
                              </TableContainer>
                          </Paper>
                              
                          </Grid>
  </Grid>};